import { render } from "./BaseSelector.vue?vue&type=template&id=fc9de7f2&scoped=true"
import script from "./BaseSelector.js?vue&type=script&lang=js"
export * from "./BaseSelector.js?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=fc9de7f2&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./BaseSelector.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2Fcomponents%2FBaseSelector%2FBaseSelector.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc9de7f2"]])

export default __exports__